class DiscountBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.code = (this.getAttribute("data-code") || "").toLowerCase();
    this.checkForDiscount();
  }

  async checkForDiscount() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) return;

      const cart = await res.json();
      const discounts = cart.discount_codes || [];

      console.log(discounts, this.code);

      const hasMatch = discounts.some(d =>
        (d.code || d.discount_code || "").toLowerCase() === this.code
      );

      if (hasMatch) {
        this.textContent = this.getAttribute("data-text") || "";
        this.removeAttribute("hidden");
      } 
    } catch (e) {
      console.error(e);
    }
  }
}

customElements.define("discount-banner", DiscountBanner);
